import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
	esp: (
		`
		<div style="text-align: justify;">
		
			<p class="mb-3">
				Roberto kaj Julio ludis pilkon. 
				Jen la pilko flugas al najbara parcelo. 
				Roberto rampas tra barilo, sed estas haltigata de ĉirkaŭvolvita drato. 
				Li ne povas moviĝi kaj laŭte krias. 
				Timigita Julio forkuras; sed aperas la iritita najbaro. 
				Li helpas al Roberto liberiĝi, sed ne redonas la pilkon kaj forpelas la knabon tra malproksima elirejo, tiel ke li devas longe iri hejmen.
			</p>
			
			<p class="mb-5">
				Laca, gratita, en ĉifitaj vestaĵoj, Roberto treniĝas hejmen preter la domo de Julio. 
				La patro de Julio vidas lin kaj admonas la filon neniam plu ludi kun tiu mizera diboĉulo. 
				Julio obeas; kaj kiam Roberto fariĝis ĉef-ministro, Julio restis simpla kamparano.
			</p>
			
			
			<p class="mb-5">* * *</p>
			
			
			<p class="mb-3">
				Ni ricevis lernejan taskon: intervjui iun konatan personon. 
				Tom tuj venis al bazaro, aŭskultis kion oni diras tie pri nia urbestro kaj prezentis tion kiel “la voĉon de l’ popolo”. 
				Kial do “Popolo” ne povus esti kromnomo de opozicia aganto? 
			</p>
			
			<p class="mb-3">
				La instruisto laŭdis Tomon. 
				Tom, inspirita de bona komenco, daŭrigis tiun vojon, verkante artikolojn, kompontiajn nur el fremdaj, subaŭskultitaj pensoj. 
				Li fariĝis sufiĉe fama kaj influa ĵurnalisto. 
				Nu, verdire, li finis malbone: oni kelkfoje atentis lin, li perdis movpovon kaj mortis sola en hospitalo.
			</p>
			
			<p class="mb-5">
				Sed mi – tute alia afero. 
				Mi ne plenumis la taskon, kaj mi ĝis nun vivas senglore kaj trankvile.
			</p>
			
			
			<p class="mb-5">* * *</p>
			
			
			<p class="mb-3">
				Diskutis Pano kaj Salo.
			</p>
			
			<p class="mb-3">
				-  Sen mi ne povas vivi Homo, li malsatos. 
				Mi estas granda kaj bezonata por ĉio!
			</p>
			
			<p class="mb-3">
				-  Kaj mi estas malgranda, sed mi troviĝas ĉie, ankaŭ en vi! 
				Sen mi la manĝaĵo ne bongustas, kaj oni ne manĝus, kvankam ĝi estis abunda!
			</p>
			
			<p class="mb-3">
				-  Ekstremokaze, mi povas esti sen vi, sed tamen resti nutriva. Sed vin oni ne povas manĝi sen io! 
			</p>
			
			<p class="mb-3">
				-  Jes, sed vin oni devas produkti speciale: semi, rikolti, baki... 
				Kaj mi estas natura produkto, kiu troviĝas ĉie: en maro, en lagoj, en tero…
			</p>
			
			<p class="mb-3">
				Tiel diskutas ili; kaj ĉu povas iu venki, se ili ambaŭ estas vivonecesaj?
			</p>
			
			<p class="article-date mb-5">
				<span>
					17 januaro, 2026
				</span>
			</p>
			
			
			<p class="mb-5">* * *</p>
			
			
			<p class="mb-3">
				Diskutis Suno kaj Luno.
			</p>
			
			<p class="mb-3">
				-  Mi donas lumon kaj vivon por ĉio vivanta. Pro mi kreskas plantoj, kantas birdoj, agadas homoj.
			</p>
			
			<p class="mb-3">
				-  Sed kiam vi foriras, ili ĝoje ĉesas kanti kaj labori, kaj havas feliĉon de ripozo, de dormo.
			</p>
			
			<p class="mb-3">
				-  Sed aperas ja aliaj estaĵoj: obskuraj, nigraj, tenebremaj. 
				Ili estas ĉasantoj kaj murdistoj; neniu bona estaĵo vagadas nokte. 
				La plantoj nokte ne ellasas oksigenon, nepran por ajna vivo, sed male, eligas venenan karbondioksidon.
			</p>
			
			<p class="mb-3">
				-  Nu bone, ni lasu flaŭron kaj faŭnon. 
				Sed Homo, la krono de la kreaĵo, - ĉu li ne ĝuas min? kiom da superbaj verkoj aperis ne pro via kruda kaj altruda fajro, sed pro mia tenera, misterioza lumo?
			</p>
			
			<p class="mb-3">
				-  Ho jes, hundoj hurlas je luno, kaj ankaŭ homoj frenezaj, allogataj de vi, vagadas nokte laŭ tegmentoj, kaj falas, kaj mortas pro via malica tento.
			</p>
			
			<p class="mb-3">
				-  Ne, mi ne logas ilin. Ili mem venas al mi, strebas al mi, ĉar ili estas de alia gento. 
				Ne ĉiuj homoj ja estas egalaj; kelkaj ne apartenas al firma mezumo, sed formas tre maldikan flankon, same palan kaj necertan, kiel mi mem. 
				Kaj same kiel mi, kiu estas ege pli malgranda ol vi, ankaŭ ili estas nur tre malgranda parto de la tuta homaro; sed ĝuste ili formas tiun taĉmenton, kiu subtenas lumon nokte, kiam vi forestas. 
				Ili savas la mondon de plena tenebro; ili kunligas la Teron kun ĉielo, kie loĝas kaj mi, kaj vi. 
				Tage ili ja ne povas ĝui vin: vi estas tro potenca, tro arda…
			</p>
			
			<p class="mb-3">
				-  Nu bone, tiu mil-ono, milion-ono de teranoj subtenas la spiritan vivon tie. 
				Sed homaro vivas ja ne per spirito, sed per simplaj aferoj: labori, manĝi, koiti… 
				Kaj tiujn eblecojn por ili donas nur mi!
			</p>
			
			<p class="mb-3">
				-  Por unuaj du taskoj – jes, sendube. Sed por la tria?? 
				Ĉu la homoj sin reproduktas tage? 
				Tage ili nur subtenas sian vivadon; sed metas fundamenton por ĝi ili preskaŭ ekskluzive nokte! 
				Sen mi la homa vivo tute ne povus daŭri!
			</p>
			
			<p class="mb-3">
				La Suno enpensiĝis, kovriĝis per nubo kaj senvorte malaperis de l’horizonto. 
				Kaj ĝian lokon okupis diafane brilanta Luno, sendanta al homoj kvieton, malstreĉitecon kaj sonĝojn pri flugo al ĉielo, kie eterne alternas sin Suno kaj Luno.
			</p>
			
			<p class="article-date mb-5">
				<span>
					28 januaro, 2026
				</span>
			</p>
			
			
			<p class="mb-5">* * *</p>
			
			
			<p class="mb-3">
				Patro admonas filon ne okupiĝi pri matematikaj problemoj, ĉar ili estas absolute ne necesaj por normala vivo. 
				La filo malobeas; ne havante paperon kaj krajonon, li desegnas geometriajn figurojn per fulgo sur muroj kaj sur planko, per vergo sur neĝkovrita grundo.
			</p>
			
			<p class="mb-3">
				Mirigita patro permesas al li aliĝi al universitato, sed nur post kiam li edziĝos kaj naskigos filon, por ke la familia nomo ne pereu vane. 
				Ja ĉiuj scias, kiel senhonta kaj malĉasta estas tia studenta vivo
			</p>
			
			<p class="mb-3">
				Kion fari, la filo prudentas kaj sekvas la postulon de l’ patro. 
				Sed geedziĝa vivo, antaŭe tute nekonata al li, tiel fascinis kaj ravis lin, ke li, plene enprofundite en ĝin, tute forgesis pri siaj matematikaj ekzercoj. 
			</p>
			
			<p class="mb-3">
				Kaj la verkojn pri konusaj sekcoj kaj ideon de aritmetika maŝino post 40 jaroj ellaboris Blaise Pascal.
			</p>
			
			<p class="article-date mb-5">
				<span>
					31 januaro, 2026
				</span>
			</p>
			
			
			<p class="mb-5">* * *</p>
			
			
			<p class="mb-3">
				Mi tiel volis komplezi lin! Mi adaptis al lia tagordo miajn kutimojn; mi suferis pro fruaj vekiĝoj kaj abundaj manĝoj; mi heroece lavis min per varmega akvo, kvankam ŝatis glacian duŝon; mi preparis bovinaĵon, kiun abomenas… 
				Mi tiel volis esti ideala edzino!
			</p>
			
			<p class="mb-3">
				Sed vane! Li ne rimarkis tion: li opiniis, ke estas normala stato, se ĉiuj vivas kiel li kaj ŝatas kion li ŝatas.
			</p>
			
			<p class="mb-3">
				Sed mi ne povis ŝati tion; kaj do, mi fine ĉesis ŝati lin mem.
			</p>
			
			<p class="mb-3">
				Fadeno, jes, ĉiam sekvas la kudrilon; sed iam la fadeno rompiĝas…
			</p>
			
			<p class="mb-5">
				Kaj se vi ĵetas perlojn antaŭ porkoj, tiuj nepre piedpremos ilin!
			</p>
			
			
			<p class="mb-5">* * *</p>


			<p class="mb-3">
				Vintro en mia urbo. Forestas elektro, ne funkcias transporto surstrate kaj hejtado hejme, liverado de gaso kaj akvo en danĝero kaj apenaŭ ekzistas. 
				Ni ĉiuj apenaŭ ekzistas, fakte.
			</p>
			
			<p class="mb-3">
				Pri ĉio tio mi modere kaj milde plendas en letero al amikino, kiu nun loĝas en Holando. 
				Nu, ĉiutagaĵoj, tiel kutimaj, ke ilin oni mencias nur pretere…
			</p>
			
			<p class="mb-3">
				Tamen… Subite mi ricevas informon, ke ŝi mendis por mi 3 brikojn laŭ la Livera Servo. 
				Mi povos varmigi ilin en gasforno aŭ, se gaso forestos, eĉ en lignofajro surstrate.
			</p>
			
			<p class="mb-5">
				Kia feliĉo! Nun mia sorto estas sekura. Mi admiras la brilan progreson de la civilizacio!
			</p>
			
			
			<p class="mb-5">* * *</p>


			<p class="mb-3">
				Li loĝis sola, kaj neniu vizitis lin. 
				Ostoza, robusta kaj inerta, li ne ĝenis pro tio; por li sufiĉis neoftaj vizitoj al urbeto por aĉeti vivnecesaĵojn, mankantajn en arbara vivo. 
				Jen ankaŭ nun li bezonis petrolon por sia forno. 
				Rapide farinte la negocon, li jam estis survoje hejmen, kiam forta sono surdigis lin. 
				La aero vibris pro potencaj ondoj. Mirigita, li haltis – kaj tuj surfaco ĉirkaŭ li krevis, kaj li falis en iun abismon, kiu ŝajne ne havis limojn. 
			</p>
			
			<p class="mb-3">
				Kiam li ekstaris antaŭ Eternulo, nur unu demando eksonis:
			</p>
			
			<p class="mb-3">
				-  Cxu vi amis iun?
			</p>
			
			<p class="mb-3">
				-  Ne!
			</p>
			
			<p class="mb-3">
				Kaj neniu plu iam aŭdis pri li.
			</p>
			
		</div>
		`
	)
}

const itemName = {
	esp: 'Kompleto 100-vorta'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemAuthor: author.esp
	}
}

export default item;